// src/service/websocket/useNiftyWebsocket.jsx

import { useEffect, useRef, useState } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { environment } from "environment/environment";

const NIFTY_WEBSOCKET_URL = environment.niftyWebsocketUrl;
const TOPIC = "/index-api-topic/option-data";

const useNiftyWebsocket = () => {
  const stompRef = useRef(null);
  const bufferRef = useRef(null);

  const [options, setOptions] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const client = new Client({
      webSocketFactory: () => new SockJS(NIFTY_WEBSOCKET_URL),
      reconnectDelay: 5000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      debug: () => {}
    });

    stompRef.current = client;

    client.onConnect = () => {
      setIsConnected(true);

      client.subscribe(TOPIC, (message) => {
        try {
          const parsed = JSON.parse(message.body);

          // Buffer updates (avoid render storm)
          bufferRef.current = parsed;
          setLastUpdated(Date.now());
        } catch (e) {
          console.error("WebSocket parse error", e);
        }
      });
    };

    client.onDisconnect = () => {
      setIsConnected(false);
    };

    client.onStompError = (frame) => {
      console.error("STOMP error:", frame.headers["message"]);
      console.error(frame.body);
      setIsConnected(false);
    };

    client.activate();

    // Throttled UI update (every 300ms)
    const interval = setInterval(() => {
      if (bufferRef.current) {
        setOptions(bufferRef.current);
        bufferRef.current = null;
      }
    }, 300);

    return () => {
      clearInterval(interval);
      client.deactivate();
    };
  }, []);

  return {
    options,
    isConnected,
    lastUpdated
  };
};

export default useNiftyWebsocket;